// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowExpanderRight16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-expander-right': IconArrowExpanderRight;
    }
}

/**
 * The icon component for the 'arrowExpanderRight' icon
 */
export class IconArrowExpanderRight extends IconSvg {
    public constructor() {
        super(arrowExpanderRight16X16);
    }
}

registerIconSvg('icon-arrow-expander-right', IconArrowExpanderRight);
export const iconArrowExpanderRightTag = 'nimble-icon-arrow-expander-right';
